module.exports = __webpack_public_path__ + "img/base.42372ee2.png";